import React, { useState} from "react";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Alert,
  Row,
  
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert"
import Select from "react-select";
import { connect} from "react-redux";
import {  withRouter, Link,useHistory} from "react-router-dom";
import { contactsCreate } from "../../../store/contacts/actions";



const LeadDetails = (props) => {
  const history = useHistory();
  



  const user = JSON.parse(localStorage.getItem("user"));


 




  const optionGroupTipoIdentificacion = [
    {

      options: [
        { label: "Cédula Ciudadanía", value: "CEDULA" },
        { label: "Pasaporte", value: "PASAPORTE" },
        { label: "Cedula de Extranjería", value: "CEDULA_EXTRANJERIA" },
        { label: "NIT", value: "NIT" },
        { label: "Otro", value: "OTRO" },
      ],
    },

  ];
  const  [selectedTipoIdentificacion, setSelectedTipoIdentificacion] = useState(null); 

  const [showAlert, setShowAlert] = useState(false)
  console.log(showAlert)
  const documentType = selectedTipoIdentificacion
  const groups =String(user.groups);
  function handleSelectTipoIdentificacion(selectedTipoContacto) {
    setSelectedTipoIdentificacion(selectedTipoContacto.value);

  }  

  const [formData, setFormData] = useState({
    first_name:"",
    last_name:"",
    contactType:"",
    
    documentNumber:"",
    gender:"",
    birthdate:"2000-01-01",
    city: "",
   
    username:props.lead.email,
    razon_social:props.lead.razon_social,
    address:props.lead.address,
    phone:props.lead.phone,

});

const {  
first_name, 
last_name, 
contactType,
address,
documentNumber, 
gender,
birthdate, 
city, 

razon_social,
username,

persona_contacto,
phone,


} =
 formData;

 console.log(formData)
  const onChange = (e) => {
    setFormData({ ...formData, 
     [e.target.name]: e.target.value });
  };
   
 
  const onSubmit = (e) => {
    e.preventDefault();
    props.contactsCreate( {
      first_name ,
      last_name ,
      username,
      contactType,
      documentType,
      documentNumber,
      gender,
      birthdate,
      city,
      persona_contacto,
   
    
      razon_social,
      address,
      phone,
    });
    setShowAlert(true)
   };

   const redirect = () => {
    history.push("/contacts");
  };
 

    return ( 
        <React.Fragment>
             <Link
              className ="btn btn-info btn-sm mb-2 "
              to="/leads">
                Volver
              </Link>{"  "}
              <Card> 
              {groups.includes("SuperAdmin") || groups.includes("Supervisor") ||  groups.includes( "Operador") || groups.includes("Crear y modificar Cliente") ? (
                <CardBody>

        {props.contactsCreated.id ? (
                        <SweetAlert
                          title="Hecho!"
                          success
                          timeout={1000}
                          showConfirm={false}
                          onConfirm={() => {
                            redirect();
                          }}
                        >
                          Se ha agregado el Contacto
                        </SweetAlert>
                         ) : null}

                        <Form className="form-control needs-validation" onSubmit={onSubmit}>   

                        { props.lead.razon_social ==='' ? (


                          // Nombre y Apellido
                        <Row>
                           <Col lg={6} className="mb-3">                    
                            <Label
                              for="nombre"
                              className="form-label"
                            >
                              Nombres
                            </Label>
                            <Input 
                              id="first_name"
                              name="first_name"
                              type="text"
                              onChange={onChange}
                              value={props.lead.first_name}
                              // valid={props.error.first_name
                              //   ? true
                              //   : props.contactsCreated && false
                              // }
                              // invalid={
                              //   props.error
                              //     ? props.error.first_name
                              //       ? true
                              //       : false
                              //     : false
                              // }
                            />
                            {/* <FormFeedback>{props.error.first_name}</FormFeedback> */}
                      
                          </Col>                  
                          <Col lg={6}  className="mb-3">                    
                            <Label
                              for="apellido"
                              className="form-label"
                            >
                              Apellidos
                            </Label>
                            <Input
                              id="last_name"
                              name="last_name"
                              type="text"
                              onChange={onChange}
                              value={props.lead.last_name}                  
                              // valid={props.error.last_name
                              //   ? true
                              //   : props.contactsCreated && false
                              // }
                              // invalid={
                              //   props.error
                              //     ? props.error.last_name
                              //       ? true
                              //       : false
                              //     : false
                              // }
                            />
                            {/* <FormFeedback>{props.error.last_name}</FormFeedback> */}
                          
                          </Col> 
                        </Row>
                        ):
                        (

                          // Razon Social y Email
                          <Row>
                             <Col lg={6} className="mb-3">                    
                            <Label
                              for="razon_social"
                              className="form-label"
                            >
                              Razon Social
                            </Label>
                            <Input 
                              id="razon_social"
                              name="razon_social"
                              type="text"
                              onChange={onChange}
                              defaultValue={props.lead.razon_social}
                              valid={props.error.first_name
                                ? true
                                : props.contactsCreated && false
                              }
                              invalid={
                                props.error
                                  ? props.error.first_name
                                    ? true
                                    : false
                                  : false
                              }
                            />
                            <FormFeedback>{props.error.first_name}</FormFeedback>
                            </Col>

                            {/* Email */}
                            <Col lg={6} className="mb-3">                    
                            <Label
                              for="username"
                              className="form-label"
                            >
                              Email
                            </Label>
                            <Input 
                              id="username"
                              name="username"
                              type="text"
                              onChange={onChange}
                              defaultValue={props.lead.email}
                              valid={props.error.username
                                ? true
                                : props.contactsCreated && false
                              }
                              invalid={
                                props.error
                                  ? props.error.username
                                    ? true
                                    : false
                                  : false
                              }
                            />
                            <FormFeedback>{props.error.username}</FormFeedback>
                            </Col>
                          </Row>
                        )
                        } 


                        {/* Direccion y telefono */}
                        <Row>
                           <Col lg={6} className="mb-3">                    
                            <Label
                              for="address"
                              className="form-label"
                            >
                              Direccion
                            </Label>
                            <Input 
                              id="address"
                              name="address"
                              type="text"
                              onChange={onChange}
                              defaultValue={props.lead.address}
                              valid={props.error.address
                                ? true
                                : props.contactsCreated && false
                              }
                              invalid={
                                props.error
                                  ? props.error.address
                                    ? true
                                    : false
                                  : false
                              }
                            />
                            <FormFeedback>{props.error.address}</FormFeedback>
                      
                          </Col>                  
                          <Col lg={6}  className="mb-3">                    
                            <Label
                              for="phone"
                              className="form-label"
                            >
                              Telefono
                            </Label>
                            <Input
                              id="phone"
                              name="phone"
                              type="text"
                              onChange={onChange}
                              defaultValue={props.lead.phone}                  
                              valid={props.error.phone
                                ? true
                                : props.contactsCreated && false
                              }
                              invalid={
                                props.error
                                  ? props.error.phone
                                    ? true
                                    : false
                                  : false
                              }
                            />
                            <FormFeedback>{props.error.phone}</FormFeedback>
                          
                          </Col> 
                        </Row>

                      {/* Tipo de identificacion y tipo de Contacto */}
                        <Row>
                          <Col lg={6} className="mb-3">
                            <Label
                              for="contactType"
                              className="form-label"
                            >
                            Tipo de Contacto
                            </Label>

                          <select
                                  className="form-select"
                                  id="contactType"
                                  name="contactType"
                                                           
                                  onChange={onChange}

                                 
                                  >
                                  <option defaultValue>Seleccione una opcion</option>
                                  <option value ="PERSONA NATURAL">
                                    Persona Natural
                                  </option>
                                  <option value ="EMPRESA">
                                    Empresa
                                  </option>
                                  <option value ="AMBOS">
                                    Ambos
                                  </option>
                                  <option value ="OTRO">
                                    Otro
                                  </option>
                          </select>
                          {props.error && props.error.contactType ? (
                                    <Alert color = 'danger' className="mt-2">{props.error.contactType}</Alert>
                                  ):null}
                                  
                              
                          </Col>
                          <Col lg={6} className="mb-3">
                            <Label
                              for="contactType"
                              className="form-label"
                            >
                            Tipo de identificación
                            </Label>
                            <Select
                            id="documentType"
                            name="documentType"
                            onChange={handleSelectTipoIdentificacion}
                            options={optionGroupTipoIdentificacion}
                            placeholder ={'Seleccione'}
                          />
                  
                          </Col>
                        </Row>


                        {/* Documento y Ciudad*/}
                        <Row>
                          <Col lg={6} className="mb-3">
                            <Label
                              for="documentNumber"
                              className="form-label"
                            >
                              Documento
                            </Label>
                            <Input
                              id="documentNumber"
                              name="documentNumber"
                              type="text"
                              onChange={onChange}
                              defaultValue={documentNumber}
                            //   valid={props.error.documentNumber
                            //     ? true
                            //     : props.contactsCreated && false
                            //   }
                            //   invalid={
                            //     props.error
                            //       ? props.error.documentNumber
                            //         ? true
                            //         : false
                            //       : false
                            //   }
                            />
                            {/* <FormFeedback>{props.error.documentNumber}</FormFeedback> */}
                          </Col>
                         


                        

                          <Col lg={6} className="mb-3">
                            <Label
                              for="city"
                              className="form-label"
                            >
                              Cuidad
                            </Label>
                            <Input
                              id="city"
                              name="city"
                              type="text"
                              onChange={onChange}
                              value={city}
                            //   valid={props.error.city
                            //     ? true
                            //     : props.contactsCreated && false
                            //   }
                            //   invalid={
                            //     props.error
                            //       ? props.error.city
                            //         ? true
                            //         : false
                            //       : false
                            //   }
                             />
                             {/* <FormFeedback>{props.error.city}</FormFeedback> */}
                          </Col>
                        </Row>

                        {/* Genero y Fecha de nacimiento */}

                        { props.lead.razon_social ==='' ? (
                        <Row>
                        <Col lg={6} className="mb-3">
                            <Label
                              for="gender"
                              className="form-label"
                            >
                            Género
                            </Label>
                            <select
                                  className="form-select"
                                  id="gender"
                                  name="gender"
                                  defaultValue={gender}                            
                                  onChange={onChange}
                                  >
                                  <option value ="Masculino">
                                  Masculino
                                  </option>
                                  <option value ="Femenino">
                                  Femenino
                                  </option>
                                  <option value ="Otro">
                                  Otro
                                  </option>
                          </select>
                          </Col>

                          <Col lg={6} className="mb-3">
                            <Label
                              for="birthdate"
                              className="form-label"
                            >
                              Fecha de Nacimiento
                            </Label>
                            <Input
                              id="birthdate"
                              name="birthdate"
                              type="date"
                              onChange={onChange}
                              value={birthdate}
                            //   valid={props.error.birthdate
                            //     ? true
                            //     : props.contactsCreated && false
                            //   }
                            //   invalid={
                            //     props.error
                            //       ? props.error.birthdate
                            //         ? true
                            //         : false
                            //       : false
                            //   }
                             />
                            {/* <FormFeedback>{props.error.birthdate}</FormFeedback> */}
                          </Col>
                        
                        </Row>
                        ): null}

                        {/* Email por si no tiene razon social */}
                        { props.lead.razon_social ==='' ? (
                           <Row>
                               {/* Email si no tienen razon_social*/}
                               <Col lg={6} className="mb-3">                    
                            <Label
                              for="email"
                              className="form-label"
                            >
                              Email
                            </Label>
                            <Input 
                              id="email"
                              name="email"
                              type="email"
                              onChange={onChange}
                              defaultValue={props.lead.username}
                              valid={props.error.username
                                ? true
                                : props.contactsCreated && false
                              }
                              invalid={
                                props.error
                                  ? props.error.username
                                    ? true
                                    : false
                                  : false
                              }
                            />
                            <FormFeedback>{props.error.username}</FormFeedback>
                            </Col>
                           </Row>
 
                            ):null
                          } 


                    

          
                        <Row className="col-lg-12 justify-content-center mt-3 mb-3">
                          <Col md={1}>
                        
                            <Button color="primary" type="submit">
                              Crear  
                            </Button>
                          </Col>
                        </Row>     
              
                      </Form>
                </CardBody>
                 ): 
                 <CardBody>
                  </CardBody>

              }  
              </Card>
        </React.Fragment>
     );
}
 
const mapStateToProps = (state) => {
  const { error, loading, contactsCreated } = state.Contacts;
  return { error, loading, contactsCreated};
};

LeadDetails.propTypes = {
  error: PropTypes.any,
  loading: PropTypes.bool,
  contactsCreated: PropTypes.object,
};
export default withRouter(connect(mapStateToProps, { contactsCreate })(LeadDetails));